<template>
  <div class="mt-3">
    <!-- <v-app> -->
      <v-card>
        <v-parallax
        height="7"
        src="https://i.pinimg.com/originals/32/8a/6c/328a6cf37271127972b7730494df7f04.jpg"
      ></v-parallax>
        <!-- <v-carousel height="100vh" class="overlay" :autoplay="true" :autoplay-timeout="5000">
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
        </v-carousel> -->
        <VueSlickCarousel
          :arrows="false"
          :dots="true"
          v-bind="slickCarouselOptions"
        >
          <img v-for="(item, i) in items" :key="i" :src="item.src" >
        </VueSlickCarousel>
      </v-card>
    <!-- </v-app> -->
    <v-parallax
        height="7"
        src="https://i.pinimg.com/originals/32/8a/6c/328a6cf37271127972b7730494df7f04.jpg"
      ></v-parallax>
  </div>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel';
  import 'vue-slick-carousel/dist/vue-slick-carousel.css';
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
  // optional style for arrows & dots
  export default {
    components: {
      VueSlickCarousel
    },
    data() {
      return {
        slickCarouselOptions: {
          arrows: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 1500,
          speed: 5000
        },
        items: [
          {
            src: "web01.jpg",
          },
          {
            src: "web02.jpg"
          }
        
        ],
      };
    },
  };
</script>

<style scoped>
.overlay {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}
</style>
